<template>
  <div class="collection">
    <tabBar :pathName="routePageName" />

    <div class="content">
      <!-- 简历消息-tab -->
      <div class="collectionName clearfix f_14" v-if="routePageName ==='talentMessage'">
        <div data-growing-container data-growing-idx="10" class="name cursor_p pr fl" @click="toggleState('passed')" >
          <span :class="queryState==='passed'?'color_blue' : 'color_40'">已通过</span>
          <span :class="queryState==='passed'?'color_blue' : 'color_9c'" class='number color_9c' v-if="messageCount.application_passed_count>0">({{messageCount.application_passed_count}})</span>
        </div>
        <div class="fl pr line mar_24">|</div>
        <div data-growing-container data-growing-idx="20" class="name cursor_p pr fl" @click="toggleState('other')" >
          <span :class="queryState==='other'?'color_blue' : 'color_40'">待通过</span>
          <span :class="queryState==='other'?'color_blue' : 'color_9c'" class='number color_9c' v-if="messageCount.application_other_count>0" >({{messageCount.application_other_count}})</span>
        </div>
        <div class="fl pr line">|</div>
        <!-- 筛选项 -->
        <div class="searchPositionList pr fl">
          <div class="searchPosition f_14 color_40 cursor_p flex" :class="[searchPosition.job_index>-1 ? 'color_blue' : '']" v-if="myPosition.list.length">
            <div class="flex1 ellipsis">{{searchPosition.job_post}}</div>
            <span class="iconfont iconxuanxiang-shouqi"></span>
          </div>
          <div class="listBox pa">
            <div class="list bg_fff">
              <div class="item f_14 clearfix cursor_p" :class="[searchPosition.job_index === -1 ? 'color_blue' :'color_40']" @click="searchMessageJobs(-1)">职位不限</div>
              <div class="item f_14 clearfix cursor_p" :class="[searchPosition.job_index === index ? 'color_blue' :'color_40']" v-for="(item,index) in myPosition.list" :key="String(index)" @click="searchMessageJobs(index)">
                <p class="ellipsis">{{item.recruit_info.job_post}}</p>
                 <!-- :class="[true?'maxWidth fl':'']" -->
                <!-- <p class="fl">(下线)</p> -->
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="group-body" v-if="routePageName == 'talentCollection'" :style="{'margin-bottom': showGroupBtn ? '-10px' : ''}">
        <div :style="{height: !showGroupBtn ? '30px' : 'auto'}" style="overflow:hidden">
          <div ref="groupRef" class="collection-list" v-show="groupLists.length > 0">
            <div class="collect-item" @click="clickCollectItem(-1)" :class="['collect-item',{'active-collect-item': -1 == currentGroupIndex}]">
              全部 <span class="collect-item-num">({{totalCount}})</span>
            </div>
            <div @click="clickCollectItem(sindex)" :class="['collect-item',{'active-collect-item': sindex == currentGroupIndex}]" v-for="(item,sindex) in groupLists" :key="sindex + 'b'">
             {{item.group_name}} <span class="collect-item-num">({{item.count}})</span>
            </div>
          </div>
        </div>

        <div class="group-btn" v-if="routePageName == 'talentCollection' && groupLists.length > 0">
          <div :class="['group-btn-item', this.showManage ? 'active-color' : '']" @click.stop="clickManage" >
            <i class="iconfont iconshezhi1"></i> 管理
            <group :isManage='true' v-if="showManage" top="40px" @close="clickManage"></group>
          </div>
          <div v-if="moreGroup" :class="['group-btn-item',showGroupBtn ? 'active-color' : '']" @click="()=>{showGroupBtn = !showGroupBtn}">
            <i :class="['iconfont',showGroupBtn ? 'iconshangyi1' : 'iconxiayi']">{{!showGroupBtn ? ' 展开' : ' 收起'}}</i>
          </div>
        </div>
      </div>
      <!-- 右侧页面布局 -->
      <div style="height: 16px"  v-if="isLoading && routePageName == 'talentCollection'" ></div>
      <skeleton :skeletonType="'resumeList'" v-if="isLoading"></skeleton>
      <resumeList v-else :classType="routePageName==='talentDelivery' ? 4 : ( (queryState !=='passed' || routePageName==='talentCollection')?3:2 )"
       @pageChange="pageChange" :isLoading="isLoading" @getDetail="getDetail" @checkUpdateList="checkUpdateList" @getList="getList" />
    </div>

    <!-- 标记不合适 -->
    <unsuitable v-if="unsuitableData.showState" @checkListDeliveries="checkListDeliveries" @hideDetails="hideDetails" />
    <!-- 简历详情 -->
    <resume-detail-box :notfindResume="notfindResume" @hideDetails="hideDetails" v-if="showDetail" @checkUpdateList="checkUpdateList" />

    <!-- 完善信息弹层 -->
    <userinfo-tips />

  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
//混入优化
import {mixinsUtils} from '@/mixins/search/utils';
// 所有接口
import actions from '@/actions/index'

import {checkUserState, get_tUser , toLogin} from '@/utils/utils';

import resumeList from '@/components/resumeList/index'
import ResumeDetailBox from '@/components/resumeDetailBox/index'
import userinfoTips from '@/components/block/userinfoTips'
import skeleton from '@/components/skeletonDiagram/index.vue'
import group from '@/components/collection/group'
//顶部导航
import tabBar from '@/components/collection/tabBar'
import Unsuitable from '@/components/delivery/Unsuitable'

export default {
  name: 'talentCollection',
  data(){
    return {
      queryState:'passed',  //passed/other 已通过/未通过
      query:{ //接口参数
        page:1,
        page_size:15
      },
      total_count:0, //总数
      isLoading:true,//是否在请求列表
      unviewed_passed_count:0,//已通过，未读数量
      unviewed_rejected_count:0, //未通过，未读数量

      showDetail:false,

      searchPosition:{ //筛选的职位
        job_index:-1,
        job_post:'筛选',
        recruit_info_id:'',
      },
      showGroupBtn: false, // 展示分组
      moreGroup: false, // 分组是否折行
      userJWT:{},
      notfindResume:false,//是否未找到简历
      // groupLists: [], // 分组信息
      // currentGroupIndex: -1, // 选中分组下标
      totalCount: 0,  // 分组简历总数
      showManage: false
    }
  },
  computed:{
    ...mapState('block',['userInfoState', 'unsuitableData']),
    ...mapState('delivery',['unviewed_job_deliveries_count']),
    ...mapState('resumeDetails',['routePageName', 'resumeDetailToken', 'resumeDetail', 'myPosition', 'resumeListObj', 'listOptions', 'listPageNumber',]),
    ...mapState('message',['messageCount']),
    ...mapState('collection',['groupList', 'groupLists', 'currentGroupIndex']),
    ...mapGetters('resumeDetails',[ 'getStoreResumeList'] ),
  },
  components:{
    resumeList,
    ResumeDetailBox,
    'userinfo-tips':userinfoTips,
    tabBar,
    skeleton,
    group,
    Unsuitable
  },
  mixins:[mixinsUtils],
  async created(){

    this.userJWT = await get_tUser();
    //页面路由变化
    this.routerChange();
    if(this.userJWT.h_t){
      //获取职位列表
      this.getMyPosition();
      // 获取投递未读数
      // this.getUnviewedCount();
      this.getGroupList()
    }

  },
  updated(){
    let height = (document.querySelector('.collection-list')) && (document.querySelector('.collection-list')).offsetHeight
    // console.log(this.$refs.groupRef)
    this.moreGroup = height > 42
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState']),
    ...mapMutations('collection',['updateGroups', 'updateCurrentIndex']),
    ...mapMutations('delivery',['updateUnviewedJobDeliveriesCount','updateCvCount']),
    ...mapMutations('resumeDetails',['updateRoutePageName', 'updateResumeDetailToken', 'updateResumeDetail', 'resetResumeListObj', 'updateResumeListObj', 'updateListOptions', 'updateResumeListObj','updateDownloadResumeInfo', 'updateShowDetailFlag', 'updateSearchResumeBasic']),
    ...mapMutations('message',['updateMessageCount']),

    ...mapActions('resumeDetails',['getMyPosition']),
    checkListDeliveries(resumeIndex) {
      this.checkUpdateList(resumeIndex)
    },
    getGroupList(){
      actions.favorites.favorites_group_info({page: 1,page_size: 15}).then(res => {
        if(res.code == 1000) {
          // this.groupLists = res.data.groups
          this.updateGroups(res.data.groups)
          this.totalCount = res.data.total_count
        }
        // 获取列表
        this.getList();
      })
    },
    //页面路由变化
    async routerChange(){
      //created事件触发的函数在这里写...

      let { name } = this.$route;
      let {
        page=1, //页数
        type='passed',
        currentGroupIndex=-1
      } = this.$route.query;
      this.updateRoutePageName(name);
      // this.currentGroupIndex = currentGroupIndex
      this.updateCurrentIndex(currentGroupIndex);
      this.queryState = type;
      this.query.page = !page ? 1 :page;

      this.isLoading = true;

      //重置搜索数据
      this.resetResumeListObj();

      if(this.userJWT.h_t){
        //更新是否完善信息(状态库)
        let userInfo = await actions.hr_accounts.getUserinfo();
        this.toggleUserInfoState(userInfo)
      }else{
        this.toggleUserInfoState(false)
      }
      // 获取分组信息
      this.getList()
    },
    // 点击管理
    clickManage(){
      this.showManage = !this.showManage
    },
    // 点击分组
    clickCollectItem(index){
      // this.currentGroupIndex = index
      this.updateCurrentIndex(index)
      this.query.page = 1;
      this.isLoading = true;
      this.encodeURI()
      // 获取列表
      this.getList();
    },
    // 切换已通过，未通过
    toggleState(state){
      if(state === this.query.state){
        return false;
      }
      this.queryState = state;
      this.query.page = 1;

      //重置搜索数据
      this.resetResumeListObj();

      this.isLoading = true;
      // 更新路由
      this.encodeURI();
      // 获取列表
      this.getList();
    },
    // 获取列表,统一入口
    async getList(){
      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          this.isLoading = false;
          // this.$router.replace({name:'talentSearchIndex'});
          return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });
      if(!checkUser){
        this.isLoading = false;

        this.unviewed_passed_count = 0;
        this.unviewed_rejected_count = 0;

        //重置搜索数据
        this.resetResumeListObj();
        return ;
      }
      if(this.routePageName === 'talentMessage'){
        this.getMessageList();
      }else{
        this.getCollectionList();
      }
      //返回顶部
      scrollTo(0,0);
    },
    // 获取简历消息列表
    getMessageList(state){
      let { recruit_info_id } = this.searchPosition;
      let query = {
        state:this.queryState,
        recruit_info_id,
        ...this.query,
      }
      actions.resume_permissions.resume_permissions(query).then(res=>{
        this.isLoading = false;
        //更新当前路由名字
        this.updateRoutePageName(this.$route.name);
        if(res.code === 1000){
          let { resumes, total_count, unviewed_passed_count, unviewed_rejected_count} = res.data;
          let tokenList = []
          resumes.forEach((item, index) => {
            tokenList.push(item.resume.token)
          })
          // 先加载列表数据，获取简历各个状态之后再修改一次列表数据
          //检查当前分页，是否异常
          if(this.replaceURI(total_count)){
            return false;
          }
          if(this.routePageName === 'talentMessage'){
            //同步列表数据
            this.updateResumeListObj({key:'message', value: resumes});
          }

          let resumeIndex = -1;
          //判断是下一页||上一页
          if(this.listPageNumber > this.listOptions.page || this.listPageNumber < this.listOptions.page){
            resumeIndex = this.listPageNumber > this.listOptions.page ? 0 : resumes.length-1;
            this.getDetail({
              index: resumeIndex,
              item: resumes[resumeIndex],
              token: resumes[resumeIndex].resume.token,
            })
          }

          this.updateListOptions({
            ... this.query,
            resumeIndex:resumeIndex,
            total_count,
          })
          this.unviewed_passed_count = unviewed_passed_count;
          this.unviewed_rejected_count = unviewed_rejected_count;
          actions.resumes.get_resume_detail({token_list: tokenList}).then(detailRes => {
            if (detailRes.code === 1000) {
              let { data } = detailRes
              let newResumes = resumes.map((item, index) => {
                return {...item, ...data[index]}
              })
              //检查当前分页，是否异常
              if(this.replaceURI(total_count)){
                return false;
              }
              if(this.routePageName === 'talentMessage'){
                //同步列表数据
                this.updateResumeListObj({key:'message', value: newResumes});
              }

              let resumeIndex = -1;
              //判断是下一页||上一页
              if(this.listPageNumber > this.listOptions.page || this.listPageNumber < this.listOptions.page){
                resumeIndex = this.listPageNumber > this.listOptions.page ? 0 : newResumes.length-1;
                this.getDetail({
                  index: resumeIndex,
                  item: newResumes[resumeIndex],
                  token: newResumes[resumeIndex].resume.token,
                })
              }

              this.updateListOptions({
                ... this.query,
                resumeIndex:resumeIndex,
                total_count,
              })
              this.unviewed_passed_count = unviewed_passed_count;
              this.unviewed_rejected_count = unviewed_rejected_count;
            }
          })

        }else{
          //重置搜索数据
          this.resetResumeListObj();

          this.unviewed_passed_count = 0;
          this.unviewed_rejected_count = 0;

          // this.$message({
          //   message: res.status.message,
          //   type: 'error'
          // });
        }
      })

    },
    // 获取简历收藏列表
    getCollectionList(){
      // console.log('获取简历收藏列表',this.query);
      let param = {
        ...this.query,
      }
      let groupList = JSON.parse(JSON.stringify(this.groupLists))
      // 总数默认先是全部分组
      let total_count = this.totalCount
      if(param.page <= 0) param.page = 1
      if(this.currentGroupIndex > (groupList.length - 1)) this.updateCurrentIndex(-1)
      if(this.currentGroupIndex > 0) {
        param.group_id = groupList[this.currentGroupIndex] && groupList[this.currentGroupIndex].group_id
        total_count = groupList[this.currentGroupIndex] && groupList[this.currentGroupIndex].count
      } else if(this.currentGroupIndex == 0) {
        total_count = groupList[this.currentGroupIndex] && groupList[this.currentGroupIndex].count
        param.all = 'false'
      } else {
        param.all = 'true'
      }
      // 更新路由
      this.encodeURI()
      // console.log(total_count,'总数');
      actions.favorites.favorites_group_info(param).then(res=>{
        this.isLoading = false;
        //更新当前路由名字
        this.updateRoutePageName(this.$route.name);
        if(res.code === 1000){
          let { resumes, groups, total_count } = res.data;
          this.totalCount = res.data.total_count
          // this.groupLists = [...groups]
          this.updateGroups([...groups]);
          //检查当前分页，是否异常
          if(this.replaceURI(total_count)){
            return false;
          }
          // resumes.forEach(item=>{
          //   item.is_favorite = true;
          // })
          let tokenList = []
          resumes.forEach((item, index) => {
            tokenList.push(item.resume.token)
          })
          // 先加载列表数据，获取简历各个状态之后再修改一次列表数据
          let resumeIndex = -1;
          //判断是下一页||上一页
          if(this.listPageNumber > this.listOptions.page || this.listPageNumber < this.listOptions.page){
            resumeIndex = this.listPageNumber > this.listOptions.page ? 0 : resumes.length-1;
            this.getDetail({
              index: resumeIndex,
              item: resumes[resumeIndex],
              token: resumes[resumeIndex].resume.token,
            })
          }
          if(this.routePageName === 'talentCollection'){
            //同步列表数据
            this.updateResumeListObj({key:'collection', value: resumes});
          }

          this.updateListOptions({
            ... this.query,
            resumeIndex: resumeIndex,
            total_count
          })
          actions.resumes.get_resume_detail({token_list: tokenList}).then(detailRes => {
            if (detailRes.code === 1000) {
              let { data } = detailRes
              let newResumes = resumes.map((item, index) => {
                return {...item, ...data[index]}
              })
              let resumeIndex = -1;
              //判断是下一页||上一页
              if(this.listPageNumber > this.listOptions.page || this.listPageNumber < this.listOptions.page){
                resumeIndex = this.listPageNumber > this.listOptions.page ? 0 : newResumes.length-1;
                this.getDetail({
                  index: resumeIndex,
                  item: newResumes[resumeIndex],
                  token: newResumes[resumeIndex].resume.token,
                })
              }
              if(this.routePageName === 'talentCollection'){
                //同步列表数据
                this.updateResumeListObj({key:'collection', value: newResumes});
              }

              this.updateListOptions({
                ... this.query,
                resumeIndex: resumeIndex,
                total_count
              })
            }
          })
        }else{
          //重置搜索数据
          this.resetResumeListObj();

          this.unviewed_passed_count = 0;
          this.unviewed_rejected_count = 0;
          // this.$message({
          //   message: res.status.message,
          //   type: 'error'
          // });
        }
      })
    },

    // 切换分页
    pageChange(pageNo){
      this.query.page = pageNo;
      //重置搜索数据
      // this.resetResumeListObj();

      this.isLoading = true;
      // 更新路由
      this.encodeURI();
      // 获取列表
      this.getList();
      // 获取各个tab的未读数
      this.getMessageCounts();
    },
    //获取简历详情
    async getDetail(options){
      // 将列表简历的基本信息存入vuex
      this.updateSearchResumeBasic({item: options.item, recommend: true})
      this.updateDownloadResumeInfo(options.item)
      // 显示骨架图loading
      this.updateShowDetailFlag(false)
      this.showDetail = true;
      actions.resume_permissions.v2resumedetails({token: options.token}).then(res=>{
        if(res.code === 80139 || res.code === 80120 || res.code === 80121){
          this.notfindResume = true;
          //显示弹层
          // this.showDetail = true;
          this.updateShowDetailFlag(true)
          return false;
        }
        this.notfindResume = false;
        if(res.code === 1000){
          let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList))

          //如果是简历消息，并且是已收藏列表，去掉红点，红点数-1
          if(this.queryState ==='passed' && this.routePageName === 'talentMessage' && !getStoreResumeList.list[options.index].viewed){
            this.unviewed_passed_count = this.unviewed_passed_count-1
            this.listData[options.index].viewed = true;

            this.updateResumeListObj({key: getStoreResumeList.listName, value: getStoreResumeList.list});
          }
          //同步数据到vuex
          this.updateResumeDetail(res.data);

          //简历详情相关url 及 参数，用作收藏等交互
          this.updateResumeDetailToken(options.token);

          //显示弹层
          // this.showDetail = true;
          this.updateShowDetailFlag(true)
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })

    },
    //隐藏详情
    hideDetails(token){
      this.showDetail = false;
      //重置详情的token相关数据
      this.updateResumeDetailToken('');
      document.body.style.position = 'initial'
      document.body.style.overflow = 'initial'
    },

    // 更新路由
    encodeURI(){
      let url = window.location.origin + window.location.pathname + '?';
      if(this.routePageName === 'talentCollection'){
        //更新分页
        url+=`page=${this.query.page}&currentGroupIndex=${this.currentGroupIndex}`
      }else{
        //更新分页
        url+=`type=${this.queryState}&page=${this.query.page}`
      }
      history.pushState(null, null, url);
    },
    // 检测当前分页数，是否合理
    replaceURI( total_count){
      let number = Math.ceil(total_count/this.query.page_size);
      if(this.query.page > number && number!==0){
        history.replaceState(null, null, '?page=1');

        this.query.page = 1;
        //重置搜索数据
        this.resetResumeListObj();

        this.isLoading = true;
        this.getList();
        return true;
      }else{
        return false;
      }
    },

    //【消息筛选】点击职位
    searchMessageJobs(index){
      if(index>-1){
        let item = this.myPosition.list[index];
        this.searchPosition = {
          job_index:index,
          job_post:item.recruit_info.job_post,
          recruit_info_id:item.recruit_info.id,
        }
        //请求第一页
        this.pageChange(1);
      }else{
        this.searchPosition = {
          job_index:-1,
          job_post:'筛选',
          recruit_info_id:'',
        }
      }
      //请求第一页
      this.pageChange(1);
      // this.hideSearchPositionBox();
    },
    // 获取各个tab的未读数
    getMessageCounts(){
      actions.message.get_message_counts().then(res=>{
        if(res.code === 1000){
          this.updateMessageCount({obj:res.data})
          this.updateCvCount(res.data.all_jds_count)
        }
      })
    },

    //需要检测列表数据是否刷新
    async checkUpdateList(resumeListIndex){
      try {

        let newList = this.getStoreResumeList.list.filter((item,index)=> index !== resumeListIndex);
        let isLastPage = Math.ceil(this.listOptions.total_count/15) === this.query.page;
        console.log(newList.length,"===================?aaaaaa")
        console.log(this.getStoreResumeList.listName,"===================?bbbbbbbb")
        if(!newList.length && this.listOptions.total_count===1){
          //同步列表数据
          this.updateResumeListObj({key:this.getStoreResumeList.listName, value:newList})
        }else {
          this.query.page = isLastPage && !newList.length ? this.query.page-1 : this.query.page;
          if(this.query.page <= 0) {
            this.query.page = 1
          }
          //向上翻页时，修改url
          if(isLastPage && !newList.length){
            // 更新路由
            this.encodeURI();
          }
          let res = {};
          if(this.routePageName === 'talentMessage'){
            this.updateResumeListObj({key:this.getStoreResumeList.listName, value:newList})
          }

          // else{
          //   this.getList()
          // }

          // if(res.code === 1000){
          //   let { resumes, total_count } = res.data;
          //   resumes.forEach(item=>{
          //     item.is_favorite = true;
          //   })
          //   //同步列表数据
          //   this.updateResumeListObj({key:this.getStoreResumeList.listName, value:resumes})

          //   this.updateListOptions({
          //     page: this.query.page,
          //     page_size: this.query.page_size,
          //     resumeIndex: -1,
          //     total_count: total_count,
          //   });

          // }else{
          //   //重置列表信息
          //   this.resetResumeListObj();
          // }
        }
        this.getList()
      } catch (error) {

      }
    },


    // 获取投递未读数
    // getUnviewedCount(){
    //   actions.job_deliveries.get_unviewed_count().then(res=>{
    //     if(res.code === 1000){
    //       let { unviewed_job_deliveries_count } = res.data;
    //       this.updateUnviewedJobDeliveriesCount(unviewed_job_deliveries_count);
    //     }
    //   })
    // },

  },
  watch: {
    //监听路由，只要路由有变化(路径，参数等变化)都有执行下面的函数，你可以
    $route: {
      handler: function (val, oldVal) {
        this.routerChange();
      },
      deep: true
    },
    //监听分页变化
    listPageNumber:{
      handler: function (val, oldVal) {
        // 翻上一页 || 下一页
        if(val < this.listOptions.page || val > this.listOptions.page){
          this.pageChange(this.listPageNumber)
        }
      },
      deep: true
    },
    groupList: {
      handler: function (val, oldVal) {
        console.log('改变了');
        this.getList();
      },
      deep: true
    }
  },
}
</script>
<style lang="scss" scoped>

@import './index.scss';
.searchPositionList {
  //transform: translateY(30%);
  z-index: 9;
  .searchPosition {
    line-height: 48px;
  }
}
</style>
